import { LogoutService } from 'services/logout/logout.service'
import { AppStore } from 'state/store'
import { onAction } from './onAction'

export const onLogout = (store: AppStore) => () =>
  onAction(store)({ type: LogoutService.Logout })
